import React, { useEffect, createContext, useContext, useState, useMemo, useCallback } from 'react';

const popSound = new Audio(require('../../static/sounds/pop_463390__vilkas_sound__vs-pop_2.mp3'));
const switchSound = new Audio(require('../../static/sounds/545477__ienba__pop-up.wav'));
const dingSound = new Audio(require('../../static/sounds/361264__japanyoshithegamer__8-bit-happy-ding.wav'));
const musicSound = new Audio(require('../../static/sounds/571236__tiagothanos__happy-melody-pt2-loop-for-games.wav'));

musicSound.volume = 0.3;
popSound.volume = 0.5;
switchSound.volume = 0.7;

// Enable looping for the music
musicSound.loop = true;
const SoundContext = createContext();

export const SoundProvider = ({ children }) => {
  //Check localStorage for saved noise preference, default to true
  const [isNoiseOn, setIsNoiseOn] = useState(() => {
    const saved = localStorage.getItem('noise');
    return saved !== null ? JSON.parse(saved) : true;
  });

//Handle music playback based on noise setting
useEffect(() => {
    localStorage.setItem('noise', JSON.stringify(isNoiseOn));
    if (isNoiseOn) {
      try {
        musicSound.currentTime = 0; //Reset to start
        const playPromise = musicSound.play();
        
        if (playPromise !== undefined) {
          playPromise.catch(e => console.log("Music play failed:", e));
        }
      } catch (error) {
        console.error("Error playing music:", error);
      }
    } else {
      musicSound.pause();
    }

    //Cleanup on unmount
    return () => {
      musicSound.pause();
    };
  }, [isNoiseOn]);

  const playPopSound = useCallback(() => {
    if (isNoiseOn) {
      try {
        popSound.currentTime = 0;
        popSound.play().catch(e => console.log("Audio play failed:", e));
      } catch (error) {
        console.error("Error playing sound:", error);
      }
    }
  }, [isNoiseOn]);
  const playDingSound = useCallback(() => {
    if(isNoiseOn) {
        try {
            dingSound.currentTime = 0;
            dingSound.play().catch(e => console.log("Audio play failed:", e));
        } catch (error) {
            console.error("Error playing sound:", error);
        }
    }
  },[isNoiseOn]);
  const playSwitchSound = useCallback(() => {
    if (isNoiseOn) {
      try {
        switchSound.currentTime = 0;
        switchSound.play().catch(e => console.log("Audio play failed:", e));
      } catch (error) {
        console.error("Error playing sound:", error);
      }
    }
  }, [isNoiseOn]);

  const value = useMemo(() => ({
    isNoiseOn,
    setIsNoiseOn,
    playPopSound,
    playDingSound,
    playSwitchSound
  }), [isNoiseOn, playPopSound, playDingSound, playSwitchSound]);

  return (
    <SoundContext.Provider value={value}>
      {children}
    </SoundContext.Provider>
  );
};

export const useSound = () => {
  const context = useContext(SoundContext);
  if (!context) {
    throw new Error('useSound must be used within a SoundProvider');
  }
  return context;
};